import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { Link } from 'foundations-components/transitional/components/Link';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import { CompletionStatuses } from '../../../constants';
import { useTracker } from '../../../context/hooks';
import { SeoRecommendations } from '../../constants';
import { RecommendationBaseView } from '../../sharedComponents/RecommendationBaseView';
import { ImageList } from '../../sharedComponents/ImageList';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const fixImageSize = (mergeModuleBody, moduleId, img) => {
  mergeModuleBody(moduleId, {
    img: {
      size_type: 'auto_custom_max',
      alt: img.alt,
      width: img.width,
      height: img.height,
      max_width: img.naturalWidth,
      max_height: img.naturalHeight,
      src: img.src
    }
  }, {
    metaData: {
      inlineEdited: false
    },
    undoData: {
      splitNext: true
    }
  });
};
const showSuccessAlert = () => {
  FloatingAlertStore.addAlert({
    sticky: true,
    type: 'success',
    titleText: I18n.text('xray-recommendation-lib.alerts.USE_CORRECTLY_SIZED_IMAGES.title'),
    message: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "xray-recommendation-lib.alerts.USE_CORRECTLY_SIZED_IMAGES.message"
    })
  });
};
const getFixButtonComponent = (mergeModuleBody, handleTrackFixImageSize) => ({
  moduleId,
  img
}) => /*#__PURE__*/_jsx(Button, {
  size: "small",
  use: "tertiary",
  onClick: () => {
    fixImageSize(mergeModuleBody, moduleId, img);
    handleTrackFixImageSize();
    showSuccessAlert();
  },
  children: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "xray-recommendation-lib.actions.USE_CORRECTLY_SIZED_IMAGES"
  })
});
export const UseCorrectlySizedImagesView = ({
  auditResult,
  editorApi
}) => {
  const {
    track
  } = useTracker();
  const {
    status,
    incorrectlySizedImages
  } = auditResult;
  const isIncomplete = status === CompletionStatuses.INCOMPLETE;
  const handleTrackFixImageSize = () => {
    track('Xray Panel', 'Xray Interaction', {
      action: 'clickedFixLink',
      recommendationType: SeoRecommendations.USE_CORRECTLY_SIZED_IMAGES
    });
  };
  const handleTrackOpenImageModule = () => {
    track('Xray Panel', 'Xray Interaction', {
      action: 'clickedFixLink',
      recommendationType: 'USE_CORRECTLY_SIZED_IMAGES_SCROLL_FROM_XRAY'
    });
  };
  const handleClickKBLink = event => {
    track('Xray Panel', 'Xray Interaction', {
      action: 'clickedLearnMoreLink',
      recommendationType: SeoRecommendations.USE_CORRECTLY_SIZED_IMAGES,
      linkAddress: event.currentTarget.href
    });
  };
  return /*#__PURE__*/_jsxs(RecommendationBaseView, {
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "xray-recommendation-lib.seo.recommendations.title.USE_CORRECTLY_SIZED_IMAGES"
    }),
    description: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "xray-recommendation-lib.seo.recommendations.description.USE_CORRECTLY_SIZED_IMAGES"
    }),
    status: status,
    children: [isIncomplete && /*#__PURE__*/_jsx(ImageList, {
      images: incorrectlySizedImages,
      subHeader: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "xray-recommendation-lib.seo.recommendations.subHeader.USE_CORRECTLY_SIZED_IMAGES"
      }),
      onTrackAction: handleTrackOpenImageModule,
      action: editorApi.openImageModule,
      fixButton: getFixButtonComponent(editorApi.mergeModuleBody, handleTrackFixImageSize)
    }), /*#__PURE__*/_jsx(View, {
      marginInlineStart: "600",
      marginBlockStart: "400",
      as: "div",
      children: /*#__PURE__*/_jsx(Link, {
        href: "https://developer.chrome.com/docs/lighthouse/performance/uses-responsive-images/#:~:text=How%20Lighthouse%20calcu%5B%E2%80%A6%5Dhe%20image%20fails%20the%20audit",
        external: true,
        onClick: handleClickKBLink,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "xray-recommendation-lib.seo.recommendations.linkText.USE_CORRECTLY_SIZED_IMAGES"
        })
      })
    })]
  });
};